import type { ElementRenderResult, RenderContext, RenderRuntime, ReportElement } from './types';

export function buildElementReactTree(
    rootElement: ReportElement,
    ctx: RenderContext,
    runtime: RenderRuntime
): ElementRenderResult {
    const rendered = rootElement.toReactNode(ctx, runtime);
    return { node: rendered.node, ready: rendered.ready };
}
